import { Button, Stack, ToggleButton, ToggleButtonGroup, Typography } from "@compass/core";
import { Input } from "components";
import { StudentCustomIdType } from "generated/openApi";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const StudentCustomIdsPaster = (props: {
  typeId?: number;
  value?: string[];
  onChange?: (customIdTypeId: number | undefined, customIds: string[]) => void;
  onAdd?: (customIdTypeId: number | undefined, customIds: string[]) => void;
}) => {
  const splitRegex = /[ ,\r\n]+/;
  const [stringValue, setStringValue] = useState<string>("");
  const [selectedCustomIdTypeId, setSelectedCustomIdTypeId] = useState<number>(1);
  const [customIdTypes, setCustomIdTypes] = useState<StudentCustomIdType[]>();
  const [firstTimeFocused, setFirstTimeFocused] = useState<boolean>(false);
  const selectedCustomIdType = customIdTypes?.find((x) => x.id === selectedCustomIdTypeId);

  let label: string | undefined = undefined;
  label = selectedCustomIdType ? `${selectedCustomIdType?.name}s` : "Student IDs";
  if (props.onAdd) label = `Add by ${label}`;

  useEffect(() => {
    ApiService.students.getCustomIdTypes().then((response) => {
      setCustomIdTypes(response);
    });
  }, []);

  useEffect(() => {
    if (props.value) setStringValue(props.value.join(", "));
  }, []);

  useEffect(() => {
    if (props.typeId) setSelectedCustomIdTypeId(props.typeId);
  }, [props.typeId]);

  const getOutputCustomIds = (stringValue: string) => {
    let outputCustomIds = stringValue.trim().split(splitRegex);
    outputCustomIds = outputCustomIds.filter((x) => x);
    return outputCustomIds;
  };

  const count = getOutputCustomIds(stringValue).length;

  return (
    <Stack spacing="sm">
      <Input
        label={label}
        placeholder={`Paste ${selectedCustomIdType?.name}s here, separated by space or comma`}
        multiline
        minRows={1}
        maxRows={5}
        value={stringValue}
        onChange={(e) => {
          const stringValue = e.target.value;
          setStringValue(stringValue);
          const outputCustomIds = getOutputCustomIds(stringValue);
          props.onChange?.(selectedCustomIdTypeId, outputCustomIds);
        }}
        onFocus={() => setFirstTimeFocused(true)}
      />

      {(firstTimeFocused || stringValue) && (
        <Stack direction="row" justifyContent={"space-between"} alignItems={"center"}>
          <ToggleButtonGroup value={selectedCustomIdTypeId} exclusive size="small">
            {customIdTypes?.map((option) => (
              <ToggleButton key={option.id} value={option.id} onMouseDown={() => setSelectedCustomIdTypeId(option.id)}>
                {option.name}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>

          <Stack direction="row" spacing="sm" alignItems={"center"}>
            {count > 0 && (
              <Typography variant="caption">
                <b>{count}</b> {selectedCustomIdType?.name}s
              </Typography>
            )}

            {props.onAdd && (
              <Button
                onClick={() => {
                  const outputCustomIds = getOutputCustomIds(stringValue);
                  props.onAdd?.(selectedCustomIdTypeId, outputCustomIds);
                  setStringValue("");
                }}
                variant="outlined"
                size="small"
              >
                + Add
              </Button>
            )}
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};
